import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api"; 
import CreateEditGame from "./popups/createGame";
import Loader from "../../common/loader";
import { toast } from 'react-toastify';
import ViewGame from "./popups/viewGame";
import { deleteGameByID } from "../../../Services/OffliineGames/offlineGamesServices";
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
const GameList = ({ data }) => {
  const tableRef = useRef(null); 
  const [isLoading, setIsLoading] = useState(true);
  const [gameModal, setGameModal] = useState(false);
  const [editGameModal, seteditGameModal] = useState(false);  
  const [viewGameModal, setViewGameModal] = useState(false);  
  const [editGameId, setEditGameId] = useState(false);
  const [gameViewId, setGameId]           = useState([]); 
  const [categoryData, setCategoryData]  = useState([]);  
  const [subjectId, setSubjectId] = useState('');
  const [gameLevelId, setGameLevelId] = useState('');
  const [rerender, setRetender] = useState(true);
  const navigate = useNavigate();
  const subjects = [
    { id: 1, name: "English" },
    { id: 2, name: "Maths" }
  ];
  const categories = [
    { id: 1, name: "Identification", subjectId: 1 },
    { id: 2, name: "Spellings", subjectId: 1 },
    { id: 3, name: "Other", subjectId: 1 },
    { id: 4, name: "Identification", subjectId: 2 },
    { id: 5, name: "Counting", subjectId: 2 },
    { id: 6, name: "Addition", subjectId: 2 },
    { id: 7, name: "Subtraction", subjectId: 2 },
    { id: 8, name: "Other", subjectId: 2 }
  ];
  const createPopupClose=(rr=true)=>{
    setGameModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  let viewGameModalClose=()=>{
    setViewGameModal(false)
  }
  const editGameModalClose=(rr=true)=>{
    seteditGameModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
const callCategories = (e) => {
  const selectedSubjectId = e.target.value;
  setSubjectId(selectedSubjectId);
  setGameLevelId("");
  if (selectedSubjectId) {
    setCategoryData(categories.filter(cat => cat.subjectId === parseInt(selectedSubjectId)));
  } else {
    setCategoryData([]);
  }
};

const reset = () => {
  setSubjectId("");
  setGameLevelId("");
  setCategoryData([]);
};
    useEffect(() => {
      if(!checkPermissions('offline_game_page') || !checkPermissions('games_navigation')){ 
        navigate('/')
      }
    },[])
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/offline/getOfflineGamesReport?category=${gameLevelId}&subject=${subjectId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "id" },
        { data: "gamename" },
         { 
          data: "subject",
          render: (data) => {
            const subject = subjects.find(sub => sub.id === data);
            return subject ? subject.name : "Unknown";
          }
        },
        { 
          data: "category",
          render: (data, type, row) => {
            const category = categories.find(cat => cat.id === data && cat.subjectId === row.subject);
            return category ? category.name : "Unknown";
          }
        },
        { data: "game_key" },
        { 
          data: null,
          title: 'Actions',
          render:  (data, type, row) => (
            `<div> 
            <span class="a-edit"><i class="bi bi-pencil-square"></i></span>
            <span class="a-view"><i class="bi bi-eye-fill"></i></span>
            <span class="a-delete"><i class="bi bi-trash-fill"></i></span>
            </div>`
          )
            }
      ],
      'columnDefs': [ {
        'targets': [5], /* column index */
        'orderable': false, /* true or false */
     }],
     createdRow: (row, data, dataIndex) => {  
      if(!checkPermissions('offline_game_edit')){
        $(row).find('.a-edit').remove();
      }
      if(!checkPermissions('offline_game_delete')){
        $(row).find('.a-delete').remove();
      }

      $(row).find('.a-edit').on('click', () => {
        seteditGameModal(true)
        setEditGameId(data.id)
      } );   
      $(row).find('.a-view').on('click', () => { setViewGameModal(true)
              setGameId(data.id)
      } );    
      $(row).find('.a-delete').on('click', () => { 
      if(window.confirm('Are you sure you want to delete this game?')){
          deleteGameByID(data.id)
          .then((response) => {
         if (response.status===true) {
            toast.success(response.message)
            setRetender(!rerender)
         }else{
          toast.error(response.errorMessage)
         }
         })
         .catch((error) => {
         toast.error('Error deleting subject:', error);
         });
        }
       } );
    },
     drawCallback: function(settings) {
      setIsLoading(false);
    },
      aaSorting: [[0, "desc"]],
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data,rerender,subjectId,gameLevelId]);

  
  return (
    <div>
    <main id="main" className="main">
       <div className="pagetitle">
          <h1>Offline Game</h1>
       </div>
       <section className="section">
          <div className="row">
             <div className="col-lg-12">
                <div className="card p-10">
                      <h5 className="card-title">
                      {checkPermissions('offline_game_create') && 
                      <button
                      type="button"
                      className="btn btn-primary float-right"                        
                      onClick={()=>{setGameModal(true)}}
                      >
                      + Add Offline Game
                      </button>}
                      
                      </h5>
                     <div className="row g-1">
                        <div className="col-md-6 col-lg-3 mb-2">
                          <select className="form-control" value={subjectId} onChange={callCategories}>
                            <option value="">--Select Subject--</option>
                            {subjects.map((subject) => (
                              <option key={subject.id} value={subject.id}>
                                {subject.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-2">
                          <select className="form-control" value={gameLevelId} onChange={(e) => setGameLevelId(e.target.value)}>
                            <option value="">--Select Category--</option>
                            {categoryData.map((category) => (
                              <option key={category.id} value={category.id}>
                                {category.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-2 d-flex align-items-end justify-content-start">
                          <button className="btn btn-primary" onClick={reset}>Reset</button>
                        </div>
                      </div>
                      {isLoading?
                      <Loader />
                      :"" }
                      <div className={isLoading?'card-body hide':'card-body'}>
                      <table
                         className="table table-striped table-hover table-bordered no-footer dataTable"
                         width="100%"
                         ref={tableRef}
                         >
                         <thead>
                            <tr>
                               <th>Game id</th>
                               <th>Name</th>
                               <th>Subject</th>
                               <th>Category</th>
                               <th>Game Key</th>
                               <th>Action</th>
                            </tr>
                         </thead>
                      </table>
                   </div>
                </div>
          </div>
 </div>
 </section>
 </main> 
 {gameModal?<CreateEditGame isShow={gameModal} close={createPopupClose} type="CREATE"/>:''}  
 {viewGameModal?<ViewGame isShow={viewGameModal} gameID={gameViewId} close={viewGameModalClose}  />:''} 
 {editGameModal?<CreateEditGame isShow={editGameModal} close={editGameModalClose} gameId={editGameId} type="EDIT"/>:''} 
 
 </div>
  );
};

export default GameList;